export class ExpiviComponentConfiguration {
  catalogueId: number;
  viewerContainer: string;
  optionContainer?: string;
  priceSelectors?: string;
  currency?: string;
  locale: 'en' | 'it';
  token: string;
  configuration?: any;
  // configuration?: ExpiviSaveConfigResult;
  preset?: any;
  constructor(init?: ExpiviComponentConfiguration) {
    Object.assign(this, init);
  }
}

export class ExpiviSaveConfigResult {
  bundle_uuid?: string;
  configured_products: ConfiguredProductOptions[];
  constructor(init?: ExpiviSaveConfigResult) {
    Object.assign(this, init);
  }
}

export class ConfiguredProductOptions {
  version: string; //interface version
  catalogue_id?: string; //product’s id
  thumbnail?: string; //thumbnail as base64 data
  configuration: {
    attributes: AttributeSerializedValue[];//configuration state for internal usage
  };
  attributes?: AttributeSerializedValue[]; //representable product specifications
  articles?: ProductArticleModel[]; //bill of materials
  constructor(init?: ConfiguredProductOptions) {
    Object.assign(this, init);
  }
}

export class AttributeSerializedValue {
  attribute_id: number; //attribute’s id in database
  attribute_name?: string; //attribute’s name (product specification name)
  attribute_value_name?: string; //attribute value (product specification value)
  attribute_value?: ExpiviAttributeValueModel; //attribute value (product specification value)
  constructor(init?: AttributeSerializedValue) {
    Object.assign(this, init);
  }
}

export class ProductArticleModel {
  models_id?: number; //component’s id in database
  models_sku: string; //part’s sku
  material_group_id?: number; //applied material’s id in database
  material_group_sku?: string; //sku of applied material on part
  price_sku?: string; //price identifier to look into pricing matrix
  price_fields?: { [key: string]: number; }; //calculated total price for each predefined field
  constructor(init?: ProductArticleModel) {
    Object.assign(this, init);
  }
}
export class ExpiviAttributeValueModel {
  value?: string;
  image_source?: string;
  offset?: number[];
  ratio?: number;
  repeat_type?: string;
  size?: string;
  rotation?: number;
  scale?: number;
  attribute_value_id?: number;
  output?: string;
  operands?: ExpiviAttributeOperandsModel[];
  calculated_value?: number;
  constructor(init?: ExpiviAttributeValueModel) {
    Object.assign(this, init);
  }
}
export class ExpiviAttributeOperandsModel {
  step?: number;
  value?: number;
  placeholder?: string;
  max_value?: number;
  min_value?: number;
  constructor(init?: ExpiviAttributeValueModel) {
    Object.assign(this, init);
  }
}


